import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import type { LeaderboardRow } from '../types';
import { LeaderboardRowItem } from './leaderboard-row';

export function LeaderboardBody({
  rows,
}: {
  rows: LeaderboardRow[];
}): ReactNode {
  const { user, isAdmin, isCollector } = useAuth();
  const navigate = useNavigate();
  const canOpenDetail = isAdmin || isCollector;
  return (
    <tbody>
      {rows.map((row, i) => (
        <LeaderboardRowItem
          key={row.id}
          row={row}
          index={i}
          isCurrent={row.id === user?.id}
          {...(canOpenDetail && {
            onClick: () => navigate(`/progress/${row.id}`),
          })}
        />
      ))}
    </tbody>
  );
}
